import { defineRuntimeConfig } from '@modern-js/runtime';

export default defineRuntimeConfig({});
